import { createFileRoute } from '@tanstack/react-router'
import { WargaPilihDesa } from '../../pages/WargaPilihDesa'

export const Route = createFileRoute('/warga/pilih-desa')({
  component: WargaPilihDesa,
})
